import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate, Link } from "react-router-dom";
import toast from "react-hot-toast";
import authService from "../services/authService";
export default function VerifyOtp() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const email = state?.email;
  const phone = state?.phone;
  const { register, handleSubmit, reset } = useForm();
  const [selectedLogin, setSelectedLogin] = useState("");
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(0);
  // 🔐 Redirect if no email & phone
  useEffect(() => {
    if (!email && !phone) navigate("/register");
  }, [email, phone, navigate]);
  // ⏳ Timer countdown 
  useEffect(() => {
    if (timer <= 0) return;
    const interval = setInterval(() => {
      setTimer(prev => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [timer]);
  // ✅ VERIFY OTP
  const onSubmit = async ({ otp }) => {
    if (!selectedLogin) {
      toast.error("Select email or phone");
      return;
    }
    try {
      setLoading(true);
      const res = await authService.verifyOtp(selectedLogin, otp);
      toast.success(res?.data?.message || "OTP verified");
      navigate("/");
    } catch (err) {
      toast.error(err?.response?.data?.message || "Invalid OTP");
    } finally {
      setLoading(false);
    }
  };
  const handleResendOtp = async () => {
    if (!selectedLogin) {
      toast.error("Select email or phone");
      return;
    }
    try {
      setLoading(true);
      await authService.resendOtp(selectedLogin);
      toast.success("OTP resent successfully");
      setTimer(60);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to resend OTP");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="container-xxl">
      <div className="authentication-wrapper authentication-basic container-p-y">
        <div className="authentication-inner">
          <div className="card">
            <div className="card-body text-center">
              {/* <img src="VITAURA" alt="Logo" className="text-center mb-3" /> */}
              <img
  src="vitauralogo.jpg"
  alt="Vitaura Logo"
  style={{
    width: "220px",
    height: "80px",
    objectFit: "contain",
    display: "block",
    margin: "0 auto",
  }}
/>
              <h4 className="mb-3">Verify OTP</h4>
              {/* EMAIL / PHONE SELECT */}
              <div className="d-grid gap-2 mb-3">
                {email && (
                  <button
                    type="button"
                    className={`btn ${selectedLogin === email
                        ? "btn-primary"
                        : "btn-outline-primary"
                      }`}
                    onClick={() => setSelectedLogin(email)}
                  >
                    {email}
                  </button>
                )}
                {phone && (
                  <button
                    type="button"
                    className={`btn ${selectedLogin === phone
                        ? "btn-success"
                        : "btn-outline-success"
                      }`}
                    onClick={() => setSelectedLogin(phone)}
                  >
                    {phone}
                  </button>
                )}
              </div>
              {/* OTP FORM */}
              <form onSubmit={handleSubmit(onSubmit)}>
                <input
                  className="form-control text-center mb-2"
                  placeholder="Enter 6-digit OTP"
                  maxLength={6}
                  {...register("otp", { required: true })}
                  disabled={!selectedLogin || loading}
                />
                <button
                  className="btn  w-100"
                  disabled={loading} 
                    style={{ backgroundColor: "#FB6C22", color: "#fff", border: "none" }}
                >
                  {loading ? "Verifying..." : "Verify OTP"}
                </button>
              </form>
              {/* RESEND */}
              {selectedLogin && (
                <div className="mt-3">
                  {timer > 0 ? (
                    <small>Resend in 00:{timer}</small>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-link"
                      onClick={handleResendOtp}
                      disabled={loading}
                    >
                      Resend OTP
                    </button>
                  )}
                </div>
              )}
              <p className="mt-3">
                Back to <Link to="/login">Login</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
